import { useState } from "react";
import { Alert, IconButton, Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const FraudNotificationStrip = () => {
  const [open, setOpen] = useState(true);
  if (!open) return null;

  return (
    <Alert
      variant="filled"
      severity="warning"
      icon={false}
      style={{
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 1300,
      }}
      sx={{
        backgroundColor: "#f9626c",
        py: 0.75,          // was 1.5
        px: 2,            // was 4
        display: "flex",
        alignItems: "center",
        "& .MuiAlert-message": {
          padding: 0,
          flex: 1,
          display: "flex",
          alignItems: "center",
        },
        "& .MuiAlert-action": {
          marginLeft: 1,
          padding: 0,
          alignSelf: "center",
        },
      }}
      action={
        <IconButton
          aria-label="close"
          color="inherit"
          size="small"
          onClick={() => setOpen(false)}
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
      }
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "center", md: "center" },
          justifyContent: "space-between",
          width: "100%",
          gap: 1.25, // tighter gap
        }}
      >
        {/* Message */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, mb: 0.25, color: "white", fontSize: "0.8rem" }}
          >
            Important:
          </Typography>
          <Typography
            variant="body2"
            title="Ignore fraudulent payment requests on WhatsApp or unofficial sources – only trust emails ending with @accredian.com."
            sx={{ lineHeight: 1.3, color: "white", fontSize: "0.8rem" }}
          >
            Ignore fraudulent payment requests on WhatsApp or unofficial sources – only
            trust emails ending with <strong>@accredian.com</strong>.
          </Typography>
        </Box>

        {/* Helpline pill – smaller */}
        {/* Helpline pill – inline label + number */}
        <Box
          sx={{
            background: "linear-gradient(135deg, rgba(255,255,255,0.25) 0%, rgba(249,98,108,0.3) 100%)",
            borderRadius: 3,
            px: 1.75,
            py: 0.65,
            border: "2px solid rgba(255, 255, 255, 0.5)",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: "white",
              fontWeight: 600,
              fontSize: "0.85rem",
              whiteSpace: "nowrap", // keep text on one line
            }}
          >
            Student Helpline No. -
          </Typography>

          <Typography
            variant="body2"
            component="a"
            href="tel:+917969547220"
            sx={{
              color: "white",
              fontWeight: 700,
              textDecoration: "none",
              fontSize: "0.85rem",
              letterSpacing: "-0.01em",
              whiteSpace: "nowrap", // keep number on one line
              "&:hover": {
                textDecoration: "underline",
                textDecorationThickness: "2px",
              },
            }}
          >
            07969547220
          </Typography>
        </Box>

      </Box>
    </Alert>

  );
};

export default FraudNotificationStrip;
